interface ActivityLogProps {
  itemId: string;
}

export function ActivityLog({ itemId: _itemId }: ActivityLogProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
        Activity
      </h3>
      <p className="text-sm text-gray-400 dark:text-gray-500 italic">
        Activity log coming soon
      </p>
    </div>
  );
}
